import React from "react";

import { WellSuperAppHomeButtonProps } from "../../types/WellSuperAppHomeButtonProps";

function WellSuperAppHomeButton({
  goToWellSuperAppHome,
  icon,
}: WellSuperAppHomeButtonProps) {
  return (
    <button className="" onClick={() => goToWellSuperAppHome()}>
      <img src={icon} alt="Home" width={42} height={42} />
    </button>
  );
}

export default WellSuperAppHomeButton;
